import { useTheme, forBrands, css, SerializedStyles } from '@core-ui/react-stitch';

const getStyles = (isBRRedesign: boolean, isMobileStyle: boolean): SerializedStyles => {
  const theme = useTheme();

  const BRDefaultStyles = css`
    ${theme.brandFontAlt}
    color: ${theme.color.bk};
    font-weight: 300;
    letter-spacing: 0.15em;
    text-transform: uppercase;
  `;

  const BRRedesignStyles = css`
    ${theme.brandFontAlt}
    color: ${theme.color.inverse.b1};                                  
    font-size: ${isMobileStyle ? '0.875rem' : '2.125rem'};
    font-weight: 400;
    letter-spacing: normal;
    text-align: center;
    text-transform: capitalize;
  `;

  const ATDefaultStyles = css`
    color: ${theme.color.b1};
    text-transform: uppercase;
  `;

  const defaultStyles = css`
    ${theme.brandFont}
    color: ${theme.color.bk};
    font-weight: 400;
    letter-spacing: normal;
    text-transform: capitalize;
  `;

  return css`
    font-size: ${isMobileStyle ? '1.125rem' : '1.5rem'};
    line-height: ${isMobileStyle ? '1.125rem' : '1.5rem'};
    padding: ${isMobileStyle ? '2rem' : '1.5rem'} 1rem 0.5rem 1rem;
    ${
      forBrands(theme, {
        at: () => ATDefaultStyles,
        br: () => (isBRRedesign ? BRRedesignStyles : BRDefaultStyles),
        brfs: () => (isBRRedesign ? BRRedesignStyles : BRDefaultStyles),
        default: () => defaultStyles
      })
    }
  `;
};

export default getStyles;
